import React from 'react'

const Heading = (props) => {
  const Heading = props.editable.type.split('/').slice(-1)[0]
  return (
    <Heading className={ props.className }>{props.content}</Heading>
  )
}

export default Heading



// WEBPACK FOOTER //
// ./app/javascript/app/site/components/content/rich_text/heading/index.js